import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserSession } from '../models/SessionUser';
import { DataPage } from './../../common/models/DataPage';
import { GaSessionConfigService } from './session.config.service';

@Injectable()
export class GaSessionDataService {

    constructor(private http: HttpClient, private sessionConfig: GaSessionConfigService) { }

    private get resourse(): string { return this.sessionConfig.serverUrl + '/api/v1/users/'; }

    signin(login: string, password: string): Observable<UserSession> {
        return this.http.post<UserSession>(this.resourse + 'signin', { login, password });
    }

    signup(user: UserSession): Observable<UserSession> {
        return this.http.post<UserSession>(this.resourse + 'users', user);
    }

    signout(): Observable<void> {
        return this.http.post<void>(this.resourse + 'signout', null);
    }

    recover(login: string): Observable<void> {
        return this.http.post<void>(this.resourse + 'passwords/recover', { login });
    }

    reset(login: string, code: string, password: string): Observable<void> {
        return this.http.post<void>(this.resourse + 'passwords/reset', { login, code, password });
    }

    changePassword(userId: string, oldPassword: string, newPassword: string): Observable<void> {
        return this.http.post<void>(this.resourse + userId + '/passwords/change', { old_password: oldPassword, new_password: newPassword });
    }

    getSessions(): Observable<DataPage<Omit<UserSession, 'user' | 'data'>>> {
        return this.http.get<DataPage<Omit<UserSession, 'user' | 'data'>>>(this.resourse + 'sessions');
    }

    getCurrentSession(): Observable<UserSession> {
        return this.http.get<UserSession>(this.resourse + 'sessions/current');
    }

    restoreSession(id: string): Observable<UserSession> {
        return this.http.post<UserSession>(this.resourse + 'sessions/restore', { session_id: id });
    }

    closeSession(id: string): Observable<UserSession> {
        return this.http.delete<UserSession>(this.resourse + 'sessions/' + id);
    }
}
